import { Action, createFeature, createReducer, on } from "@ngrx/store";
import { createRehydrateReducer } from "@shared/utils/state_rehydration.util";
import {
  PasswordPolicy,
  PasswordPolicyState,
} from "@core/models/password-policy.interface";
import { ApiStatus } from "@core/models/common.interface";
import { passwordActions } from "./actions";

export const initialPasswordPolicyState: PasswordPolicyState = {
  status: ApiStatus.initial,
  passwordPolicy: {} as PasswordPolicy,
};

const passwordPolicyFeature = createFeature({
  name: "passwordPolicy",
  reducer: createRehydrateReducer<PasswordPolicyState, Action>(
    "PasswordPolicyState",
    createReducer(
      initialPasswordPolicyState,
      on(passwordActions.setPasswordPolicy, (_state, _event) => ({
        ...initialPasswordPolicyState,
        status: ApiStatus.loading,
      })),
      on(passwordActions.setPasswordPolicySuccess, (_state, event) => ({
        status: ApiStatus.loaded,
        passwordPolicy: event.passwordPolicy!,
      })),
      on(passwordActions.setPasswordPolicyFail, (_state) => ({
        ...initialPasswordPolicyState,
        status: ApiStatus.error,
      }))
    ),
    initialPasswordPolicyState
  ),
});

export const {
  name: passwordPolicyFeatureKey,
  reducer: passwordPolicyReducer,
} = passwordPolicyFeature;
